import { Commit } from 'vuex';
import { AccountState } from './state';

export interface AccountActionTypes{
    commit: Commit,
    state: AccountState,
    getters: any
}

export enum AccountAction {
    GET_SOCIETES = 'ACCOUNT_GET_SOCIETES',
}
